// Client helper utilities for CoursWeb API types
// This provides typed Hono client factory functions for easy consumption
import { hc } from "hono/client";
/**
 * Creates a typed Hono client for the main CoursWeb API
 * @param baseUrl - The base URL for the API (e.g., 'https://api.nthumods.com')
 * @returns Typed Hono client for the main API
 */
export function createMainApiClient(baseUrl) {
    return hc(baseUrl);
}
/**
 * Creates a typed Hono client for the secure CoursWeb API
 * @param baseUrl - The base URL for the secure API (e.g., 'https://auth.nthumods.com')
 * @returns Typed Hono client for the secure API
 */
export function createSecureApiClient(baseUrl) {
    return hc(baseUrl);
}
/**
 * Creates both API clients with the provided URLs
 * @param config - Configuration object with API URLs
 * @returns Object with both API clients
 */
export function createApiClients(config) {
    const clients = {};
    if (config.mainApiUrl) {
        clients.api = createMainApiClient(config.mainApiUrl);
    }
    if (config.secureApiUrl) {
        clients.auth = createSecureApiClient(config.secureApiUrl);
    }
    return clients;
}
//# sourceMappingURL=client.js.map